import { render, staticRenderFns } from "./RecuperarSenhaCodigo.vue?vue&type=template&id=1def580d&scoped=true"
import script from "./RecuperarSenhaCodigo.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaCodigo.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaCodigo.vue?vue&type=style&index=0&id=1def580d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def580d",
  null
  
)

export default component.exports